import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthorizationRequestService } from '@core/service';
import { noWhiteSpaceValidator } from '@mynexus/mynexus-ui-lib';
import { SelectItem } from 'primeng/api';
import { finalize } from 'rxjs/operators';


@Component({
    selector: 'app-hipps-code-dialog',
    templateUrl: './hipps-code-dialog.component.html',
    styleUrls: ['./hipps-code-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HippsCodeDialogComponent implements OnInit {
  @Input() show = true;
  @Input() cancelBtn = {text: 'Cancel', icon: ''};
  @Input() submitBtn = {text: 'Add', icon: ''};
  @Output() selectHippsCode = new EventEmitter<string>();

  availableHipps: SelectItem[] = [];
  isLoadingHipps = false;
  hippsNotFound = false;
  hippsCodeForm: FormGroup;

  constructor(
    private readonly ref: ChangeDetectorRef,
    private readonly authorizationRequestService: AuthorizationRequestService
  ) {}

  ngOnInit() {
    this.buildHippsCodeForm();
  }

  buildHippsCodeForm() {
    this.hippsCodeForm = new FormGroup({
      searchText: new FormControl('', [
        Validators.minLength(3),
        Validators.maxLength(5),
        Validators.required,
        noWhiteSpaceValidator
      ]),
      selectedHippsCode: new FormControl('', [Validators.required])
    });
  }

  get searchText() {
    return this.hippsCodeForm.get('searchText');
  }
  get selectedHippsCode() {
    return this.hippsCodeForm.get('selectedHippsCode');
  }

  searchForHippsCodes() {
    this.availableHipps = [];
    this.isLoadingHipps = true;
    this.authorizationRequestService.getHippsCodes(this.searchText.value)
      .pipe(
        finalize(() => {
          this.isLoadingHipps = false;
          this.ref.markForCheck();
        })
      )
      .subscribe(
        res => {
          if (res && res.length > 0) {
            this.hippsNotFound = false;
            this.availableHipps = res.map(({ hippscode }) => ({
              value: hippscode,
              label: hippscode
            }));
          } else {
            this.hippsNotFound = true;
            this.selectedHippsCode.setValue('');
          }
        },
        () => this.hippsNotFound = true
      );
  }

  handleDialog(value: any) {
    this.selectHippsCode.emit(value);
    this.hippsCodeForm.reset();
    if (!value) {
      this.hippsNotFound = false;
    }
    this.availableHipps = [];
  }
}
